export const API_REQUEST = 'API_REQUEST'
export const API_SUCCESS = 'API_SUCCESS'
export const API_ERROR = 'API_ERROR'
export const API_STATUS_RESET = 'API_STATUS_RESET'
export const UPDATE_AUTH = 'UPDATE_AUTH'
